import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["article", "button", "container"]
  static values = {
    initialCount: { type: Number, default: 6 },
    loadCount: { type: Number, default: 3 },
    currentIndex: { type: Number, default: 0 }
  }

  connect() {
    this.currentIndexValue = this.initialCountValue
    this.hideExcessArticles()
  }

  hideExcessArticles() {
    this.articleTargets.forEach((article, index) => {
      if (index >= this.currentIndexValue) {
        article.style.display = 'none'
      }
    })

    // 如果所有文章都已显示，隐藏按钮
    if (this.currentIndexValue >= this.articleTargets.length) {
      this.buttonTarget.style.display = 'none'
    }
  }

  loadMore() {
    const articles = this.articleTargets
    const endIndex = Math.min(this.currentIndexValue + this.loadCountValue, articles.length)

    // 显示下一批文章
    for (let i = this.currentIndexValue; i < endIndex; i++) {
      articles[i].style.display = 'block'
    }

    this.currentIndexValue = endIndex

    // 如果所有文章都已显示，隐藏按钮
    if (this.currentIndexValue >= articles.length) {
      this.buttonTarget.style.display = 'none'
    }
  }
}

